<template>
  <div id="contenedor-contratos-consulta-tool-bar">
    <v-toolbar
      flat>
      <date-picker
        v-model="filtros.fechaInicio"
        cols="2"
        label="F. Inicio"
        dense>
      </date-picker>
      <date-picker
        v-model="filtros.fechaTermino"
        cols="2"
        label="F. Termino"
        dense>
      </date-picker>
      <custom-text-field
        v-model="filtros.buscarTexto"
        label="Buscar"
        cols="3"
        dense
        append-icon="mdi-magnify">
      </custom-text-field>
      <custom-select
        v-model="filtros.idContratoEstatus"
        label="Estatus"
        cols="2"
        clearable
        :items="getEstatus"
        item-value="id"
        item-text="nombre">
      </custom-select>
      <filtros
        :contratos="contratos"
        :filtros="filtros">
      </filtros>
      <v-spacer></v-spacer>
      <v-btn-toggle
        v-model="filtros.tipoLista"
        dense>
        <v-btn>
          <v-icon>
            fa-list
          </v-icon>
        </v-btn>
        <v-btn>
          <v-icon>
            mdi-view-grid
          </v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            outlined
            v-bind="attrs"
            v-on="on"
            @click="exportarPdf"
            :loading="seEstaEnviando"
            :disabled="seEstaEnviando">
            <v-icon>
              fa-solid fa-file-pdf
            </v-icon>
          </v-btn>
        </template>
        <span>
          Exportar a PDF
        </span>
      </v-tooltip>
    </v-toolbar>
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ReportesContratosConsultaToolBar',
  components: {
    DatePicker,
    CustomTextField,
    CustomSelect,
    Filtros,
  },
  props: {
    contratos: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      seEstaEnviando: false,
    };
  },
  methods: {
    exportarPdf() {
      this.$emit('exportarPdf');
    },
  },
  computed: {
    getEstatus() {
      if (!this.contratos) return [];
      const todosEstatus = this.contratos
        .map(({ estatus }) => ({ ...estatus }))
        .filter((value) => Object.keys(value).length !== 0)
        .sort((a, b) => (`${a.nombre}`).localeCompare(b.nombre));

      return this.$removerDumplicadosArrayObj(todosEstatus, 'id');
    },
  },
};
</script>

<style lang="scss">

</style>
